import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AppReadySync({ children }) {
  const location = useLocation();
  const navKey = `${location.pathname}${location.search}${location.hash}`;

  useEffect(() => {
    document.body.setAttribute("data-app-ready", "true");
    return () => {
      document.body.removeAttribute("data-app-ready");
    };
  }, [navKey]);

  return children;
}

export { AppReadySync };
